<template>
  <div>
    <h5 class="text-center text-color-red" v-show="allow_above_medication_text">
      {{ translatedFields['above_please_tell_us_more_about_yourself'] }}
    </h5>
    <h5 class="text-center">
      {{ translatedFields['please_tell_us_more_about_yourself'] }}
    </h5>
    <!-- first name / last name-->
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['first_name'] }}
          </label>
          <input class="form-control"
                 type="text"
                 data-vv-as="First Name"
                 name="firstName"
                 v-validate="modelValidations.firstName"
                 v-model="model.firstName"
                 placeholder="ex: Mike"
                 :disabled = "this.$store.state.matchUser.firstName !=''"
          />
          <small class="text-danger" v-show="firstName.invalid">
            {{ getError('firstName', 'First') }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['last_name'] }}
          </label>
          <input class="form-control"
                 type="text"
                 data-vv-as="Last Name"
                 name="lastName"
                 v-validate="modelValidations.lastName"
                 v-model="model.lastName"
                 placeholder="ex: Andrew"
                :disabled = "this.$store.state.matchUser.lastName !=''"
          />
          <small class="text-danger" v-show="lastName.invalid">
            {{ getError('lastName') }}
          </small>
        </div>
      </div>
    </div>
    <!--    email-->
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label :class="((this.$store.state.site.notify_patient === '3') || (this.$store.state.site.notify_patient === '4') || (this.$store.state.site.notify_patient === null)) ? 'required' : '' " class="control-label">
            {{ translatedFields['email'] }}
          </label>
          <input type="email"
                 name="email"
                 ref="email"
                 data-vv-as="Email"
                 v-validate="((this.$store.state.site.notify_patient === '3') || (this.$store.state.site.notify_patient === '4') || (this.$store.state.site.notify_patient === null )) ? modelValidations.email : ''"
                 v-model="model.email"
                 class="form-control">
          <small class="text-danger" v-show="email.invalid">
            {{ getError('email') }}
          </small>
        </div>
      </div>
    </div>
    <!--    address gender -->
    <div v-if="this.$store.state.matchUser.address != ''" class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['address'] }}
          </label>
          <!-- <input class="form-control"
                 type="text"
                 data-vv-as="Address"
                 name="address"
                 v-validate="modelValidations.address"
                 v-model="model.address"
                 placeholder="123 Main St, Los Angeles, CA"
          /> -->
          <el-autocomplete  data-vv-as="Address"
                            name="address"
                            v-validate="modelValidations.address"
                            v-model="model.address"
                            :fetch-suggestions="lookup"
                            placeholder="123 Main St, Los Angeles, CA"
                            @select="handleAddressSelect"
                            @blur="handleAddressBlur"
                            :clearable="true"
                            :trigger-on-focus="false"
                            :disabled = "this.$store.state.matchUser.address != ''">
          </el-autocomplete>
          <small class="text-danger" v-show="address.invalid">
            {{ getError('address') }}
          </small>
          <small class="text-danger" v-show="address_smartystreets_selected.invalid">
            {{ address_smartystreets_selected.error_message }}
          </small>
        </div>
      </div>
    </div>
    <div v-if="this.$store.state.matchUser.address === ''" class="row">
      <div class="col-md-10 col-md-offset-1">
        <Address id="patient" @updateAddress="updateAddress" :componentsInsurance="model.addressComponents" :disabled = "this.$store.state.matchUser.address != ''"  wizardStep="medical" />
        <small class="text-danger" v-if="address_error" v-text="address_error">
          {{ address_error }}
        </small>
      </div>
    </div>
    <!--GENDER-->
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['gender'] }}
          </label>
          <el-select size="large"
                     data-vv-as="Gender"
                     v-validate="modelValidations.gender"
                     placeholder="Single Select"
                     name="gender"
                     v-model="model.gender"
                     :disabled = "this.$store.state.gender.length > 0 && this.$store.state.matchUser.gender !== null && this.$store.state.matchUser.gender !== ''">
              <el-option v-for="option in this.$store.state.gender"
                         class="select-danger"
                         :value="option.name"
                         :label="option.name"
                         :key="option.name">
              </el-option>
          </el-select>
          <small class="text-danger" v-show="gender.invalid">
            {{ getError('gender') }}
          </small>
        </div>
      </div>

      <!--RACE-->
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['race'] }}
          </label>
          <el-select size="large"
                     data-vv-as="Race"
                     v-validate="modelValidations.race"
                     placeholder="Single Select"
                     name="race"
                     v-model="model.race"
                     :disabled = "this.$store.state.race.length > 0 && this.$store.state.matchUser.race !== null && this.$store.state.matchUser.race !== ''">
              <el-option v-for="option in this.$store.state.race"
                         class="select-danger"
                         :value="option.name"
                         :label="option.name"
                         :key="option.name">
              </el-option>
          </el-select>
          <small class="text-danger" v-show="race.invalid">
            {{ getError('race') }}
          </small>
        </div>
      </div>
    </div>
    <!--ETHNICITY-->
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['ethnicity'] }}
          </label>
          <el-select size="large"
                    data-vv-as="Ethnicity"
                    v-validate="modelValidations.ethnicity"
                    placeholder="Single Select"
                    name="ethnicity"
                    v-model="model.ethnicity"
                    :disabled = "this.$store.state.ethnicity.length > 0 && this.$store.state.matchUser.ethnicity !== null && this.$store.state.matchUser.ethnicity !== ''">
              <el-option v-for="option in this.$store.state.ethnicity"
                        class="select-danger"
                        :value="option.name"
                        :label="option.name"
                        :key="option.name">
              </el-option>
          </el-select>
          <small class="text-danger" v-show="ethnicity.invalid">
            {{ getError('ethnicity') }}
          </small>
        </div>
      </div>
    </div>
    <!-- dob phone-->
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['date_of_birth'] }}
          </label>
          <input class="form-control date-cleave-format"
                 type="text"
                 name="dob_pretty"
                 v-model="model.dob_pretty"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 @change="validateDate($event.target.value)"
                 placeholder="ex: 12/22/1980"
                 maxlength="10"
                :disabled = "this.$store.state.matchUser.dob != ''"
          />
          <small class="text-danger" v-if="errorDate" v-text="errorDate">
            {{ errorDate }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['phone'] }}
          </label>
          <input class="form-control phone-cleave-format"
                 type="text"
                 data-vv-as="Phone"
                 name="phone"
                 @input="changePhone"
                 v-validate="modelValidations.phone"
                 v-model="model.phone"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 placeholder="ex: (954) 000-0000"
                 maxlength="14"
          />
          <small class="text-danger" v-show="phone.invalid">
            {{ getError('phone') }}
          </small>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker, Autocomplete} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import axios from 'axios'
  import Cleave from 'cleave.js'
  import Address from './Address'
  require('cleave.js/dist/addons/cleave-phone.us')
//  PATIENT NAME
//  PATIENT ADDRESS
//  PATIENT SEX
//  PATIENT DOB
//  PATIENT PHONE NUMBER
//  PATIENT EMAIL ADDRESS
//  PATIENT INSURANCE DETAILS=
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      Address
    },
    mixins: [FormatterUtils, ValidationUtils],
    data () {
      return {
        address_error: '',
        matchPhone: false,
        matchFormattedPhone: false,
        editedPhone: false,
        double_entry_email: process.env.DOUBLE_ENTRY_EMAIL,
        suggestions: [],
        smartystreets_key: process.env.SMARTYSTREETS_KEY,
        apply_cdc_question_formatter: String(process.env.APPLY_CDC_QUESTION_FORMATTER) === 'true',
        force_valid_address: process.env.FORCE_VALID_ADDRESS === 'true',
        symptomatic_question_name: process.env.SYMPTOMATIC_QUESTION_NAME || 'Symptomatic',
        symptomatic_onset_question_name: process.env.SYMPTOMATIC_ONSET_QUESTION_NAME || 'Symptom Onset',
        answers_es: {},
        answers_zh: {},
        errorDate: '',
        questionErrorDate: [],
        answer_no: 'No',
        isEmailForTesting: false,
        allow_above_medication_text: String(process.env.ALLOW_ABOVE_MEDICATION_TEXT) === 'true',
        fields_en: {
          first_name: 'First Name',
          address: 'Address',
          address2: 'Address 2',
          last_name: 'Last Name',
          email: 'Email',
          ethnicity: 'Ethnicity',
          gender: 'Gender',
          phone: 'Phone',
          race: 'Race',
          date_of_birth: 'Date Of Birth',
          please_tell_us_more_about_yourself: 'Please tell us more about yourself',
          answer_required: 'Answer required'
        },
        translatedFields: '',
        model: {
          partialMatch: true,
          firstName: '',
          lastName: '',
          dob: '',
          dob_pretty: '',
          email: '',
          address: '',
          address2: '',
          gender: '',
          phone: '',
          race: '',
          ethnicity: '',
          patientid: '',
          confirmation_number: '',
          addressComponents: '',
          completed: ''
        },
        modelValidations: {
          firstName: {
            min: 2,
            required: true
          },
          lastName: {
            min: 2,
            required: true
          },
          // dob: {
          //   required: true,
          //   date_format: ' este mm-dd-yyyy',
          //   // eslint-disable-next-line
          //   regex: /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/
          // },
          email: {
            required: true,
            email: true
          },
          address: {
            min: 5,
            required: true
          },
          gender: {
            required: true
          },
          race: {
            required: true
          },
          ethnicity: {
            required: true
          },
          phone: {
            required: true,
            min: 14,
            regex: '^(?:(?:\\+?1\\s*(?:[.-]\\s*)?)?(?:\\(\\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\\s*\\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\s*(?:[.-]\\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.-]\\s*)?([0-9]{4})(?:\\s*(?:#|x\\.?|ext\\.?|extension)\\s*(\\d+))?$'
          }
        },
        address_smartystreets_selected: {
          invalid: false,
          error_message: 'Looks like we don\'t know this address, please make sure the address is correct',
          first_result: ''
        }
      }
    },
    methods: {
      updateAddress (data) {
        this.model.addressComponents = data
        this.address_error = ''
      },
      async validate () {
        if (!this.model.dob) {
          this.errorDate = 'Date Of Birth field is required'
        } else if (this.isFutureDate(this.model.dob_pretty)) {
          this.errorDate = 'Date Of Birth should not be in the future'
        } else if (!this.errorDate.includes('must be valid')) {
          this.errorDate = ''
        }
        let isAddressValid = true
        if (this.$store.state.matchUser.address === '') {
          this.address_error = ''
          if (!this.model.addressComponents) {
            this.address_error = 'All the fields are required'
            return false
          }
          for (var o in this.model.addressComponents) {
            if (!this.model.addressComponents[o] && o !== 'county_fips' && o !== 'plus4_code') {
              this.address_error = 'All the fields are required'
              return false
            }
          }
          isAddressValid = false
          if (this.force_valid_address && !this.address_smartystreets_selected.invalid) {
            isAddressValid = true
          }
          if (!this.force_valid_address) {
            isAddressValid = true
          }
        }
        if ((await this.$validator.validateAll() === true) && this.errorDate === '' && isAddressValid) {
          return new Promise((resolve, reject) => {
            this.translatedFields['update'] = 'Submitting.. Please wait'
            axios.post(process.env.SERVER_URI + '/update_match/' + this.$store.state.site.code, this.model)
              .then(async (response) => {
                if (response.data === false) {
                  this.errorData = 'Error updating Data!'
                  reject(new Error('Error updating Data!'))
                } else {
                  this.errorData = ''
                  this.$store.state.matchUser.confirmation_number = response.data.confirmation_number
                  this.$store.state.matchUser.isCompleted = response.data.is_completed
                  //
                  await axios.get(process.env.SERVER_URI + '/get/results/' + this.$store.state.site.code + '/' + this.$store.state.matchUser.confirmation_number)
                    .then((response) => {
                      this.$store.state.matchUser.result = response.data
                      this.$emit('result', response.data)
                    }).catch(() => {
                      this.errorData = 'Invalid Data or server issues!'
                    })
                }
                resolve(true)
              }).catch(() => {
                this.errorData = 'Invalid Data or server issues!'
                reject(new Error('Invalid Data or server issues!'))
              })
          })
        }
      },
      changePhone () {
        this.phoneTransaction = false
      },
      lookup (queryString, cb) {
        if (queryString) {
          axios
          .get('https://us-autocomplete-pro.api.smartystreets.com/lookup?key=' + this.smartystreets_key + '&search=' + queryString + '&max_results=5')
          .then(response => {
            this.suggestions = []
            var arr = []
            if (response.data.suggestions) {
              response.data.suggestions.forEach((suggestion) => {
                arr.push({
                  value: suggestion.street_line + ', ' + suggestion.city + ', ' + suggestion.state + ' ' + suggestion.zipcode
                })
              })
              let links = arr
              let results = queryString ? links.filter(this.createFilter(queryString)) : links
              if (results.length === 1) {
                this.address_smartystreets_selected.first_result = results[0].value
              }
              // call callback function to return suggestions
              cb(results)
            } else {
              let error = []
              let links = error
              let results = queryString ? links.filter(this.createFilter(queryString)) : links
              cb(results)
            }
          })
          .catch(error => {
            console.log(error)
            // this.userMessage('Error getting bill fields: ' + error.message, 'error');
          })
        }
      },
      createFilter (queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      showAddressSmartystreetsError () {
        this.address_smartystreets_selected.invalid = true
        this.errors.add({ // to do
          field: 'address',
          msg: this.address_smartystreets_selected.error_message
        })
      },
      hideAddressSmartystreetsError () {
        this.address_smartystreets_selected.invalid = false
        this.errors.remove({
          field: 'address'
        })
      },
      handleAddressBlur (item) {
        let showAddressSmartystreetsError = true
        if (typeof item.target !== 'undefined' && item.target.value !== 'undefined') {
          if (this.address_smartystreets_selected.first_result !== '' &&
                  this.address_smartystreets_selected.first_result.toLowerCase().indexOf(item.target.value.toLowerCase()) === 0) {
            showAddressSmartystreetsError = false
            item.target.value = this.address_smartystreets_selected.first_result
          }
        }
        if (showAddressSmartystreetsError === true) {
          this.showAddressSmartystreetsError()
        }

        this.$on('input', function () {
          this.hideAddressSmartystreetsError()
        })
      },
      handleAddressSelect (item) {
        this.$emit('input', item.value)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      translateToSpanish (option) {
        if (this.$store.state.lang.value === 'ES' && this.answers_es) {
          return this.answers_es[option]
        } else {
          if (this.$store.state.lang.value === 'ZH' && this.answers_zh) {
            return this.answers_zh[option]
          } else {
            return option
          }
        }
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      }
    },
    computed: {
      firstNameFromMatch () {
        if (this.$store.state.matchUser.firstName && this.$store.state.ethnicity && this.$store.state.race && this.$store.state.ethnicity) {
          return this.$store.state.matchUser
        }
      },
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      },
      questionsDateValidation () {
        return this.$store.state.questions
      },
      ...mapFields(['firstName', 'lastName', 'email', 'address', 'address2', 'gender', 'race', 'ethnicity', 'dob', 'phone', 'questions', 'confirmation_email'])
    },
    watch: {
      firstNameFromMatch () {
        this.model.firstName = this.$store.state.matchUser.firstName
        this.model.lastName = this.$store.state.matchUser.lastName
        this.model.address = this.$store.state.matchUser.address
        this.model.dob = this.$store.state.matchUser.dob
        this.model.patientid = this.$store.state.matchUser.patientid
        this.model.confirmation_number = this.$store.state.matchUser.confirmation_number
        this.model.completed = this.$store.state.matchUser.isCompleted
        if (this.$store.state.matchUser.phone) {
          if (this.$store.state.matchUser.phone.indexOf('(') >= 0) {
            this.matchPhone = true
            this.model.phone = this.$store.state.matchUser.phone
          } else {
            this.matchFormattedPhone = true
            this.model.phone = this.$store.state.matchUser.phone
          }
        }
        this.model.email = this.$store.state.matchUser.email
        if (this.$store.state.matchUser.gender) {
          this.model.gender = this.$store.state.matchUser.gender
        }
        if (this.$store.state.matchUser.race) {
          this.model.race = this.$store.state.matchUser.race
        }
        if (this.$store.state.matchUser.ethnicity) {
          this.model.ethnicity = this.$store.state.matchUser.ethnicity
        }
        if (this.model.dob !== '') {
          let dateCleave = new Cleave('.date-cleave-format', {
            date: true,
            delimiter: '/',
            datePattern: ['m', 'd', 'Y']
          })
          this.model.dob_pretty = dateCleave.getFormattedValue()
          if (this.model.dob.length === 10) {
            let dateParts = this.model.dob.split('/')
            this.model.dob = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
          }
        }
      },
      language () {
        this.checkLanguage()
      },
      'model.dob_pretty': {
        handler: function (dobValue) {
          let dateCleave = new Cleave('.date-cleave-format', {
            date: true,
            delimiter: '/',
            datePattern: ['m', 'd', 'Y']
          })
          this.model.dob_pretty = dateCleave.getFormattedValue()
          if (dobValue.length === 10) {
            let dateParts = dobValue.split('/')
            this.model.dob = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
          }
        },
        deep: true
      },
      'model.phone': {
        handler: function (after, before) {
          let newPhoneValue = this.$store.state.matchUser.phone
          if (after !== this.$store.state.matchUser.phone && this.editedPhone) {
            newPhoneValue = after
          }
          newPhoneValue = newPhoneValue.replace(/\D/g, '')
          if (newPhoneValue.length > 3) {
            this.model.phone = '(' + newPhoneValue.substring(0, 3) + ') ' + newPhoneValue.substring(3, 6) + '-' + newPhoneValue.substring(6, 10)
          } else {
            this.model.phone = after
          }
          this.editedPhone = true
        },
        deep: true
      }
    }
  }
</script>
<style scoped>

>>> .el-select--large{
      width: 100%;
    }

>>> .el-autocomplete{
      width: 100%;
    }

  .required:after {
    content:" *";
    color: red;
  }

  h5{
    margin-bottom: 25px;
  }

  .display-none {
    display: none;
  }

  .text-color-red {
    color: red;
  }

  .generic-answer {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PatientMatch/Wizard/MedicationDataStep.vue